import Header from 'components/typography/Header'
import { Link } from 'components/misc/Link'
import Carousel from 'nuka-carousel'

import styles from './styles/Awards.css'

const AWARDS_LINKS = {
  future: 'https://future.com/how-to-build-gpt-3-for-science/',
  nature: 'https://www.nature.com/articles/d41586-020-01324-6',
  sciencemag: 'https://science.sciencemag.org/content/367/6478/606',
  axios: 'https://www.axios.com/ai-artificial-intelligence-future-of-research-2ca24e11-19c0-4bfa-82dd-d9657cbc9329.html',
  statnews: 'https://www.statnews.com/2018/12/13/solving-fake-news-problem-science/',
  natureindex: 'https://www.natureindex.com/news-blog/new-bot-flags-scientific-research-studies-that-cite-retracted-papers'
}

const AwardsLink = ({ name, children }) => (
  <Link className={styles.imgContainer} href={AWARDS_LINKS[name]} target='_blank' rel='noopener noreferrer'>
    {children}
  </Link>
)

export const Awards = () => (
  <div className={styles.awardlogo}>
    <div className={styles.award}>
      <img loading='lazy' alt='istme' src={`${CONFIG.assetsBaseURL}/images/awards/ismte.svg`} />
      <div className={styles.label}>
        ISMTE People's Choice Award
      </div>
    </div>
    <div className={styles.award}>
      <img loading='lazy' alt='alpsp' src={`${CONFIG.assetsBaseURL}/images/awards/alpsp.svg`} />
      <div className={styles.label}>
        ALPSP Award for Innovation in Publishing
      </div>
    </div>
    <div className={styles.award}>
      <img loading='lazy' alt='nsf' src={`${CONFIG.assetsBaseURL}/images/awards/nsf.svg`} />
      <div className={styles.label}>
        NSF Phase 1 SBIR Grant
      </div>
    </div>
    <div className={styles.award}>
      <img loading='lazy' alt='nih' src={`${CONFIG.assetsBaseURL}/images/awards/nih.svg`} />
      <div className={styles.label}>
        NIH/NIDA SBIR Fast-track grant
      </div>
    </div>
    <div className={styles.award}>
      <img loading='lazy' alt='vesalius prize' src={`${CONFIG.assetsBaseURL}/images/awards/karger-prize.png`} />
      <div className={styles.label}>
        Vesalius Prize Runner Up
      </div>
    </div>
  </div>
)

export const Press = () => (
  <div className={styles.press}>
    <div className={styles.pressArticles}>
      <Carousel
        slidesToScroll={1}
        slidesToShow={1}
        dragging
        wrapAround
        framePadding='2rem'
        renderCenterLeftControls={({ previousSlide }) => (
          <div className={styles.carouselChevron} onClick={previousSlide}><i className='fa fa-arrow-left' /></div>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <div className={styles.carouselChevron} onClick={nextSlide}><i className='fa fa-arrow-right' /></div>
        )}
        defaultControlsConfig={{
          pagingDotsStyle: {
            transform: 'translateY(150%)'
          }
        }}
      >
        <AwardsLink name='future'>
          <img loading='lazy' className={styles.pressArticle} alt='future' src={`${CONFIG.assetsBaseURL}/images/press/future-article.jpg`} />
        </AwardsLink>
        <AwardsLink name='nature'>
          <img loading='lazy' className={styles.pressArticle} alt='nature' src={`${CONFIG.assetsBaseURL}/images/press/nature-article.jpg`} />
        </AwardsLink>
        <AwardsLink name='axios'>
          <img loading='lazy' className={styles.pressArticle} alt='axios' src={`${CONFIG.assetsBaseURL}/images/press/axios-article.jpg`} />
        </AwardsLink>
        <AwardsLink name='sciencemag'>
          <img loading='lazy' className={styles.pressArticle} alt='science' src={`${CONFIG.assetsBaseURL}/images/press/science-article.jpg`} />
        </AwardsLink>
        <AwardsLink name='statnews'>
          <img loading='lazy' className={styles.pressArticle} alt='statp' src={`${CONFIG.assetsBaseURL}/images/press/statp-article.jpg`} />
        </AwardsLink>
        <AwardsLink name='natureindex'>
          <img loading='lazy' className={styles.pressArticle} alt='natureindex' src={`${CONFIG.assetsBaseURL}/images/press/nature-index-article.jpg`} />
        </AwardsLink>
      </Carousel>
    </div>
    <div className={styles.presslogo}>
      <div className={styles.press}>
        <AwardsLink name='future'>
          <img loading='lazy' alt='future' src={`${CONFIG.assetsBaseURL}/images/press/future-logo.svg`} />
        </AwardsLink>
      </div>
      <div className={styles.press}>
        <AwardsLink name='nature'>
          <img loading='lazy' alt='nature' src={`${CONFIG.assetsBaseURL}/images/press/nature-logo.svg`} />
        </AwardsLink>
      </div>
      <div className={styles.press}>
        <AwardsLink name='sciencemag'>
          <img loading='lazy' className={styles.scienceLogo} alt='science' src={`${CONFIG.assetsBaseURL}/images/press/science-logo.svg`} />
        </AwardsLink>
      </div>
      <div className={styles.press}>
        <AwardsLink name='axios'>
          <img loading='lazy' alt='axios' src={`${CONFIG.assetsBaseURL}/images/press/axios-logo.svg`} />
        </AwardsLink>
      </div>
      <div className={styles.press}>
        <AwardsLink name='statnews'>
          <img loading='lazy' alt='stat-plus' src={`${CONFIG.assetsBaseURL}/images/press/statp-logo.svg`} />
        </AwardsLink>
      </div>
      <div className={styles.press}>
        <AwardsLink name='natureindex'>
          <img loading='lazy' alt='nature-index' src={`${CONFIG.assetsBaseURL}/images/press/nature-index-logo.svg`} />
        </AwardsLink>
      </div>
    </div>
  </div>
)

export const AwardsAndPress = () => {
  return (
    <div className={styles.panel}>
      <Header level={2} className={styles.header}>Awards & Press</Header>
      <Awards />
      <Press />
    </div>
  )
}

export default AwardsAndPress
